import {useRef, useState} from 'react';
import {logActionEvent} from '../../@template/utility/FirebaseAnalytics';

type StatusSetter = (message: string | undefined, silent?: boolean, metadata?: Record<string, unknown>) => void;

interface ActionStatus {
  actionError: string | undefined;
  actionSuccess: string | undefined;
  actionWarning: string | undefined;
  setActionError: StatusSetter;
  setActionSuccess: StatusSetter;
  setActionWarning: StatusSetter;
}

export const useActionState = (containerName: string, actionTypeSubmitting: string | undefined): ActionStatus => {
  const [actionError, setActionError] = useState<string | undefined>(undefined);
  const [actionSuccess, setActionSuccess] = useState<string | undefined>(undefined);
  const [actionWarning, setActionWarning] = useState<string | undefined>(undefined);

  const actionTypeSubmittingRef = useRef(actionTypeSubmitting);
  actionTypeSubmittingRef.current = actionTypeSubmitting;

  const createSetter = (eventName: string, setState: (msg: string | undefined) => void): StatusSetter => {
    return (message, silent = false, metadata = {}) => {
      if (actionTypeSubmittingRef.current && (message || silent)) {
        logActionEvent(eventName, containerName, actionTypeSubmittingRef.current, metadata);
      }
      if (!message) {
        setState(undefined);
        return;
      }
      setState(message);
    };
  };

  return {
    actionError,
    actionSuccess,
    actionWarning,
    setActionError: createSetter("action_error", setActionError),
    setActionSuccess: createSetter("action_success", setActionSuccess),
    setActionWarning: createSetter("action_warning", setActionWarning),
  };
};